import { createSettings, type Settings } from "../../domain/settings/model/settings";
import type { SettingsRepository } from "../../domain/settings/settings-repository";

/** localStorageが使用不可な環境向けのフォールバック実装。セッション内のみ保持する。 */
export class InMemorySettingsRepository implements SettingsRepository {
  private settings: Settings = createSettings();

  load(): Settings {
    return this.settings;
  }

  save(settings: Settings): void {
    this.settings = settings;
  }
}
